import { PostLaunchOverviewTokenMetrics } from "@/components/app/profile/token-post-launch-overview";
import { Skeleton } from "@/components/ui/skeleton";
import { getVisiblePrice } from "@/utils/currency";

import { useTokenMetrics } from "../use-token-metrics";

export const LaunchedTileExtraContent = ({
  publicKey,
}: {
  publicKey: string;
}) => {
  const {
    specificCoinLoading,
    focusExchangeRate,
    tokenDetails,
    tokenSummary,
    selectedLaunchedToken,
  } = useTokenMetrics(publicKey);

  const tokenPriceUsd = tokenDetails?.coinPrice
    ? getVisiblePrice(tokenDetails.coinPrice)
    : 0;

  return (
    <>
      {specificCoinLoading ? (
        <>
          <div className="flex flex-col items-center justify-center gap-2">
            <Skeleton className="h-8 w-32" />
            <Skeleton className="h-4 w-48" />
          </div>
          <div className="mt-4 flex flex-row gap-4">
            <Skeleton className="h-24 w-full" />
            <Skeleton className="h-24 w-full" />
          </div>
        </>
      ) : (
        <PostLaunchOverviewTokenMetrics
          {...{
            metricsLoading: false,
            coinData: selectedLaunchedToken ?? null,
            tokenPriceUsd,
            focusExchangeRate,
            tokenSummary: tokenSummary ?? null,
            username: selectedLaunchedToken?.coinUsername ?? "",
            publicKey,
          }}
        />
      )}
    </>
  );
};
